/** Projekttypen: Single (PT), Kontingent, Festpreis. Legacy-Alias Budget → Kontingent. */

import { AngebotList, Kunde, ProjektList } from '../types';

export const ANGEBOT_BOARD_STATUS = 'Angebot';
export const ANGEBOT_BOARD_COLUMN_ID = 'angebot-board';

export function normalizeProjektTyp(typ?: string | null): string {
  if (typ === 'Budget') return 'Kontingent';
  return typ || 'Single';
}

export function isKontingentProjektTyp(typ?: string | null): boolean {
  return normalizeProjektTyp(typ) === 'Kontingent';
}

export function isFestpreisProjektTyp(typ?: string | null): boolean {
  return normalizeProjektTyp(typ) === 'Festpreis';
}

export function projektTypLabel(typ?: string | null): string {
  const n = normalizeProjektTyp(typ);
  if (n === 'Kontingent') return 'Kontingent';
  if (n === 'Festpreis') return 'Festpreis';
  return 'Single';
}

/** Chip-Farbe analog zu den bestehenden Single/Kontingent-Farben. */
export function projektTypAccent(typ?: string | null): string {
  const n = normalizeProjektTyp(typ);
  if (n === 'Kontingent') return '#ff9800';
  if (n === 'Festpreis') return '#00897b';
  return '#2196f3';
}

export function isOffeneAngebotPipeline(status: string): boolean {
  return status === 'Entwurf' || status === 'Gesendet' || status === 'Gewonnen';
}

export function angebotPipelineLabel(status?: string | null): string {
  if (!status) return '';
  return status === 'Zurueckgezogen' ? 'Zurückgezogen' : status;
}

/** Offene Angebote ohne verknüpftes Projekt; abgeschlossene nur mit Toggle. */
export function angebotOhneProjektSichtbar(
  a: Pick<AngebotList, 'projekt_id' | 'status'>,
  showAbgeschlossen: boolean,
): boolean {
  if (a.projekt_id) return false;
  if (isOffeneAngebotPipeline(a.status)) return true;
  return showAbgeschlossen;
}

export function mapAngebotToProjektRow(a: AngebotList): ProjektList {
  return {
    id: a.id,
    name: a.titel,
    personentage: a.personentage ?? undefined,
    projekt_typ: a.projekt_typ,
    erstellt_am: a.erstellt_am,
    status: { id: 0, name: ANGEBOT_BOARD_STATUS, sort_order: -1 },
    kunde: a.kunde_id
      ? ({ id: a.kunde_id, name_des_unternehmens: a.kunde_name || '' } as Kunde)
      : undefined,
    source: 'angebot',
    angebotNummer: a.angebotsnummer,
    angebotPipelineStatus: a.status,
    nettobetrag: a.nettobetrag,
  };
}

export function boardRowKey(row: Pick<ProjektList, 'id' | 'source'>): string {
  return `${row.source === 'angebot' ? 'angebot' : 'projekt'}-${row.id}`;
}
